<div class="t-popup popup-patientDetails" *ngIf="ce.ErrorType != ''" style="display: block">
  <div class="t-popup-close"></div>

  <div class="t-popup-frame error-w">
    <div class="t-popup-body">
      <button class="t-btn-popup-close" aria-label="close popup" (click)="close()"></button>

      <h2 style="color: #d7a95b; text-align: center">
        {{ ce.ErrorType }}
        {{
          ce.calendarForm || ce.alreadyHasExam || ce.sessionExpiration || ce.consentError
            ? ''
            : ('GUI.errorMessages.Error' | translate)
        }}
      </h2>

      <div
        style="display: flex; justify-content: center"
        class="l-flex l-flex-w t-fieldmargin patient-details"
        style="display: flex; justify-content: center"
      >
        <p style="text-align: center">
          {{ ce.calendarForm ? '' : ce.Error }}
        </p>
        <button class="save_patieont" (click)="login()" *ngIf="ce.ErrorType === 'Session'">
          {{ 'GUI.Buttons.Login' | translate }}
        </button>
        <button
          class="save_patieont"
          (click)="refreshSession()"
          *ngIf="ce.ErrorType === 'Session About To Expire'"
        >
          {{ 'GUI.Buttons.Stay Connected' | translate }}
        </button>
        <button class="save_patieont" (click)="login(true)" *ngIf="ce.logError">
          {{ 'GUI.Buttons.Back To Login' | translate }}
        </button>
      </div>
      <div
        *ngIf="ce.calendarForm"
        style="
          display: flex;
          align-items: center;
          justify-content: space-around;
          align-items: center;
          justify-content: space-between;
          margin-top: 1em;
        "
      >
        <button class="save_patieont" style="min-width: 7.9em" (click)="close(true)">
          {{ 'GUI.Buttons.Save' | translate }}
        </button>
        <button class="delete_patieont" style="min-width: 7.9em; margin: 0" (click)="close(false)">
          {{ 'GUI.Buttons.Cancel' | translate }}
        </button>
      </div>

      <!-- ======= Consent Notice Action (Start) ======= -->
      <div class="consent-actions" *ngIf="ce.consentError && ce.consentAction">
        <button class="accept" (click)="runConsentAction()">
          {{ ce.consentActionLabelKey | translate }}
        </button>
        <button class="cancel" (click)="close()">
          {{ 'GUI.Buttons.Cancel' | translate }}
        </button>
      </div>
      <!-- ======= Consent Notice Action (End) ======= -->

      <div
        *ngIf="ce.alreadyHasExam"
        style="
          display: flex;
          align-items: center;
          justify-content: space-around;
          align-items: center;
          justify-content: space-between;
          margin-top: 1em;
        "
      >
        <button class="cancel" style="min-width: 7.9em; margin: 0" (click)="close(false)">
          {{ 'GUI.Buttons.No' | translate }}
        </button>
        <button class="accept" style="min-width: 7.9em" (click)="close(true)">
          {{ 'GUI.Buttons.Yes' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
